import React from 'react';
import HeroCard from './hero-card';
import { ContentfulModules } from '../../helpers/modules';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var HeroCardCompound = function HeroCardCompound(props) {
  return _jsx(HeroCard, {
    title: props.title,
    ctaText: props.ctaText,
    children: _jsx(ContentfulModules, {
      modules: props.links
    })
  });
};

export default HeroCardCompound;
//# sourceMappingURL=index.js.map